interface LogoProps {
  className?: string;
  style?: React.CSSProperties;
  gradient?: boolean;
}

const LogoCompact: React.FC<LogoProps> = ({
  className,
  style,
  gradient = true,
}) => {
  if (gradient) {
    return (
      <div className="flex items-center shrink-0" style={style}>
        <div
          className="relative inline-flex items-center shrink-0 transition-all duration-300 group-hover:scale-[1.02]"
          style={{
            WebkitMaskImage: "url('/logo.png')",
            maskImage: "url('/logo.png')",
            WebkitMaskSize: "contain",
            maskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
            WebkitMaskPosition: "left center",
            maskPosition: "left center",
          }}
        >
          {/* Gradient fill */}
          <div className="absolute inset-0 bg-gradient-to-r from-church-blue-900 via-sky-600 to-church-gold-500 group-hover:brightness-110 transition-all duration-300" />
          <img
            src="/logo.png"
            alt="Église de Dieu Garizim"
            width={772}
            height={287}
            decoding="async"
            className={`w-auto object-contain opacity-0 pointer-events-none ${className || "h-10 sm:h-12 md:h-14 lg:h-16 max-w-[160px] xs:max-w-[200px] sm:max-w-[260px] md:max-w-[300px]"}`}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center shrink-0">
      <img
        src="/logo.png"
        alt="Église de Dieu Garizim"
        width={772}
        height={287}
        decoding="async"
        className={`w-auto object-contain ${className || "h-10 sm:h-12 md:h-14 lg:h-16 max-w-[160px] xs:max-w-[200px] sm:max-w-[260px] md:max-w-[300px]"}`}
        style={style}
      />
    </div>
  );
};

export const LogoFull = ({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div className="flex items-center justify-start shrink-0 w-full">
      <img
        src="/logo-church-of-god.png"
        alt="Église de Dieu Garizim"
        width={864}
        height={476}
        decoding="async"
        className={`w-auto object-contain ${className || "h-10 sm:h-12 md:h-14 lg:h-16 max-w-[180px] xs:max-w-[220px] sm:max-w-[280px] md:max-w-[320px]"}`}
        style={style}
      />
    </div>
  );
};

export default LogoCompact;
